/* eslint-disable */

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AnnotationPage: ['Page', 'UnprocessedPage'],
    ArtboardRevisionItem: [
      'Revision',
      'RevisionDeleted',
      'RevisionUnavailable',
    ],
    AuditLogItem: [
      'AcceptMembershipInviteAudit',
      'AddMemberPermissionGroup',
      'ApprovedEducationRequestAudit',
      'ArchiveProject',
      'AttachFeatureFlagAudit',
      'CancelLicenseAudit',
      'ChangeAccountLinkingAudit',
      'ChangedPlanAudit',
      'ChangeRestrictedUploadsAudit',
      'ChangeScimAutoLinkAudit',
      'ChangeSecurityEmailAudit',
      'ChangeUnlimitedStorageOverrideEnabled',
      'ChangeUnlimitedTrial',
      'ChangeWorkspaceProfileEnabled',
      'ChangeWorkspaceProfileIsOfficial',
      'ChangeWorkspaceProfileShortUrl',
      'ChangeWorkspaceProfileVisibility',
      'ConfigureEncryptionKeysAudit',
      'ConvertToEducationWorkspaceAudit',
      'CreateMembershipAudit',
      'CreatePermissionGroup',
      'CreatePermissionGroupRelation',
      'CreateWorkspaceAudit',
      'CreditAudit',
      'DeleteMembershipAudit',
      'DeleteOrganizationAudit',
      'DeletePermissionGroup',
      'DetachFeatureFlagAudit',
      'DisableMembershipAudit',
      'DisableSsoAudit',
      'DowngradedSsoMembershipProvisionedAudit',
      'GeneratedDocumentsFeedAudit',
      'InstallIntegrationAudit',
      'NewEducationRequestAudit',
      'PaymentMethodConvertedToInvoiceAudit',
      'RejectEducationRequestAudit',
      'RemoveMemberPermissionGroup',
      'RemovePermissionGroupRelation',
      'RequestInfoEducationRequestAudit',
      'ResetScimTokenAudit',
      'RestoreMembershipAudit',
      'SetDesignSystemsEligibilityAudit',
      'SetRestrictedUploadsEligibilityAudit',
      'SetScimEnabledAudit',
      'SetSsoConfigAudit',
      'SetSsoEligibilityAudit',
      'SetWorkspaceExpiredVersionsRulesAudit',
      'SsoMembershipProvisionedAudit',
      'SupportAccessDisabledAudit',
      'SupportAccessEnabledAudit',
      'TransferOrganizationAudit',
      'TrialAmendAudit',
      'UnarchiveProject',
      'UninstallIntegrationAudit',
      'UnknownAudit',
      'UpdateMembershipAudit',
      'UpdatePermissionGroup',
      'UpdateWorkspaceAudit',
      'UpgradePersonalWorkspaceAudit',
    ],
    BasePreviewChangedEvent: [
      'PreviewCreatedEvent',
      'PreviewDeletedEvent',
      'PreviewUpdatedEvent',
    ],
    BaseProjectAccessChangedEvent: [
      'ProjectAccessGrantedEvent',
      'ProjectAccessRevokedEvent',
    ],
    BaseProjectChangedEvent: [
      'ProjectArchivedEvent',
      'ProjectChangedEvent',
      'ProjectCreatedEvent',
      'ProjectDeletedEvent',
      'ProjectMemberAddedEvent',
      'ProjectMemberChangedEvent',
      'ProjectMemberRemovedEvent',
      'ProjectPermanentlyDeletedEvent',
      'ProjectRestoredEvent',
      'ProjectTransferredEvent',
      'ProjectUnarchivedEvent',
      'ProjectWorkspaceAccessLevelChangedEvent',
    ],
    BaseShareChangedEvent: [
      'ShareAccessRevokedEvent',
      'ShareArchivedEvent',
      'ShareDeletedEvent',
      'ShareDeletedPermanentlyEvent',
      'ShareProjectChangedEvent',
      'ShareRestoredEvent',
      'ShareTransferredEvent',
      'ShareUpdatedEvent',
    ],
    BillingHistoryEntry: ['CreditTransaction', 'CustomerInvoice'],
    BillingPlanInfo: ['AppStoreBillingPlan', 'CloudBillingPlan', 'LicensePlan'],
    CatchUpStrategy: [
      'DownloadLatestVersionCatchUp',
      'DownloadPatchesCatchUp',
      'OutOfDateBaseVersionCatchUp',
      'RemoteMigrationCatchUp',
    ],
    CollaborativePatch: ['LocalCollaborativePatch', 'RemoteCollaborativePatch'],
    CommunityItem: [
      'CommunityGrid',
      'CommunityHero',
      'CommunityListing',
      'CommunitySlider',
    ],
    CommunityPublicationQuery: [
      'CommunityGrid',
      'CommunityListing',
      'CommunitySlider',
    ],
    Component: ['ColorVariable', 'LayerStyle', 'Symbol', 'TextStyle'],
    CurrentSubject: [
      'Artboard',
      'ColorVariable',
      'LayerStyle',
      'Page',
      'Symbol',
      'TextStyle',
      'UnprocessedSubject',
    ],
    FrameGroup: ['Artboard', 'Frame'],
    FrameRevisionItem: ['Revision', 'RevisionDeleted', 'RevisionUnavailable'],
    Image: ['ResponsiveImage', 'SingleImage'],
    InvitableUserOrPermissionGroup: ['PermissionGroup', 'WorkspaceMembership'],
    MigrationEvent: [
      'MigrationCompleted',
      'MigrationFailed',
      'MigrationStarted',
    ],
    PaymentDetails: [
      'CreditCardPaymentDetails',
      'InvoicePaymentDetails',
      'NoPaymentDetails',
    ],
    PermissionGroupRelation: [
      'PermissionGroupRelationProject',
      'PermissionGroupRelationShare',
    ],
    ProjectMembershipPaginationItem: [
      'PermissionGroupRelationProject',
      'ProjectMembership',
    ],
    ShareCollectionChangedEvent: [
      'ShareAddedToCollectionEvent',
      'ShareRemovedFromCollectionEvent',
    ],
    ShareMembershipPaginationItem: [
      'PermissionGroupRelationShare',
      'ShareMembership',
    ],
    ShareOwner: ['PublicOrganization', 'PublicUser'],
    SignInResponse: ['MFACredentials', 'SignInCredentials'],
    StorageItem: ['Project', 'Share'],
    SubscriptionInfo: ['AppStoreSubscription', 'CloudSubscription'],
    TransferDestination: ['Project', 'Workspace'],
    TrashedItem: ['Project', 'Share', 'TrashedProject', 'TrashedShare'],
    UserNotification: [
      'AddShareMemberNotification',
      'CommentNotification',
      'DownloadableAssetRenderedNotification',
      'FolderArchivedNotification',
      'FolderPermanentlyDeletedNotification',
      'FolderTrashedNotification',
      'MentionNotification',
      'StarNotification',
      'WorkspaceInvitedNotification',
    ],
    VersionHistoryItem: ['Version', 'VersionDeleted', 'VersionUnavailable'],
  },
}
export default result
